import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Text } from '@chakra-ui/react'
import { Location } from '@leid/api-locations'
import Link from 'next/link'

import { buildDate } from 'app/utils/dates'
import { ItemApi } from 'appTypes/items'
import { CartFormValues } from 'appTypes/orders'
import { handleProductImageFallback } from 'utils/imageFallback'
import { normalizeUrl } from 'utils/normalizeUrl'
import { trimStringToLength } from 'utils/trimStringToLength'

import { CardSummary, ImageWrapper, StyledCard } from './styles'

type Props = {
  product: ItemApi
  values: CartFormValues
  closerLocation: Location | undefined
}

type QueryParameters = {
  rentedFrom?: string
  rentedTo?: string
  locationId?: string
  regionId?: string
  managerId?: string
}

const RelatedProductCard = ({ product, values, closerLocation }: Props): JSX.Element => {
  const { t } = useTranslation(['common'])

  // useEffect(() => {
  //   loadAvailabilityData(product)
  // }, [])

  // useEffect(() => {
  //   calculateAvailabilityTextInfo()
  // }, [values.returnAt, values.endDate, values.startDate, values.pickupAt, locations, availabilities, openingHours])

  // const loadAvailabilityData = async (product: ItemApi) => {
  //   const request: GetCalendarListRequest = {
  //     startDate: startOfMonth(new Date()),
  //   }

  //   const calendarResponse = await apiClient.getProductCalendarList(product.id, request)
  //   if (calendarResponse.success && calendarResponse.data) {
  //     setAvailabilities(calendarResponse.data)
  //   }

  //   const openingHoursResponse = await apiClient.getProductOpeningHours(product.id)
  //   if (openingHoursResponse.success && openingHoursResponse.data) {
  //     setOpeningHours(openingHoursResponse.data)
  //   }
  // }

  // const calculateAvailabilityTextInfo = () => {
  //   if (
  //     !availabilities ||
  //     !openingHours ||
  //     !values.endDate ||
  //     !values.returnAt ||
  //     !values.startDate ||
  //     !values.pickupAt ||
  //     locations.length === 0
  //   ) {
  //     setAvailableLocation(undefined)
  //     return
  //   }

  //   const rentedFrom = buildDate(values.startDate, values.pickupAt)
  //   const rentedTo = buildDate(values.endDate, values.returnAt)

  //   for (const location of locations) {
  //     const isAvailable = isProductAvailable(
  //       location.id,
  //       rentedFrom,
  //       rentedTo,
  //       undefined,
  //       availabilities,
  //       openingHours,
  //       true,
  //       true,
  //       1,
  //     )
  //     if (isAvailable) {
  //       setAvailableLocation(location)
  //       return
  //     }
  //   }

  //   setAvailableLocation(null)
  // }

  const sortedImages =
    product?.products[0] && [...(product?.products[0].images ?? [])].sort((a, b): number => a.id - b.id)

  const getProductQueryParams = (): QueryParameters => {
    const urlParts: QueryParameters = {}

    if (values.startDate && values.pickupAt) {
      const rentedFrom = buildDate(values.startDate, values.pickupAt)
      urlParts.rentedFrom = rentedFrom.toISOString()
    }

    if (values.endDate && values.returnAt) {
      const rentedTo = buildDate(values.endDate, values.returnAt)
      urlParts.rentedTo = rentedTo.toISOString()
    }

    if (closerLocation) {
      urlParts.locationId = closerLocation.id.toString()
      if (closerLocation.regionId) {
        urlParts.regionId = closerLocation.regionId.toString()
      }
    } else {
      if (values.selectedLocationId) {
        urlParts.locationId = values.selectedLocationId.toString()
      }
      if (values.selectedRegionId) {
        urlParts.regionId = values.selectedRegionId.toString()
      }
    }

    if (values.managerId) {
      urlParts.managerId = values.managerId.toString()
    }

    return urlParts
  }

  // Image variants handling:

  const [currentThumbnailUrl, setCurrentThumbnailUrl] = useState<string | undefined>(sortedImages[0].miniUrl)
  const [errorLevel, setErrorLevel] = useState(0)

  const handleThumbnailImageErrorFallback = (index: number) => {
    handleProductImageFallback(
      sortedImages[index],
      currentThumbnailUrl,
      errorLevel,
      setCurrentThumbnailUrl,
      setErrorLevel,
    )
  }

  return (
    <Link
      key={product.id}
      href={{
        pathname: `/products/${normalizeUrl(product.name, product.id)}`,
        query: getProductQueryParams(),
      }}
    >
      <StyledCard>
        <ImageWrapper>
          <img
            loading="lazy"
            src={currentThumbnailUrl}
            alt=""
            onError={() => {
              handleThumbnailImageErrorFallback(0)
            }}
          />
        </ImageWrapper>

        <CardSummary isBigger={false}>
          <Text fontSize="sm" fontWeight="bold" lineHeight="1.2" wordBreak="break-all">
            {trimStringToLength(product?.name ?? '', 40)}
          </Text>

          <Text fontSize="xs" marginTop="4px">
            {closerLocation ? t('availableAtLocation', { locationName: closerLocation.name }) : ''}
          </Text>
        </CardSummary>
      </StyledCard>
    </Link>
  )
}

export default RelatedProductCard
